import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const pageBuilderViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView, Permission.LandingPageBuilderView],
}

export const pageBuilderModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsModify, Permission.LandingPageBuilderModify],
}

export const landingAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.LandingAdminPanel],
}
